import Platform from '../Platform'
import { placeImage } from './helpers'

const getQueryParams = (params, url) => {
  let href = url
  let reg = new RegExp('[?&]' + params + '=([^&#]*)', 'i')
  let queryString = reg.exec(href)
  return queryString ? queryString[1] : null
}

export default class App extends Platform {
  constructor () {
    super({
      clientId: process.env.VUE_APP_CLIENT_ID,
      clientSecret: process.env.VUE_APP_CLIENT_SECRET,
      features: {
        prototype: false,
        vector: false
      }
    })
  }

  init () {
    this.platform = getQueryParams('platform', window.location.href) || 'gsuite-spreadsheet'

    // Load Plugin Settings and log into Analytics
    if (window.loadPlugin) {
      window.loadPlugin()
    }
  }

  insertItem (file) {
    placeImage(file)
  }

  openURL (url) {
    window.open(url)
  }
}
